import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal }                               from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                                       from '@angular/forms';
import { TranslateService }                             from '@ngx-translate/core';

import { ConfirmService }            from '../../messages/confirm/confirm.service';
import { GlobalDatePipe }            from '../../shared/pipes/global-date.pipe';
import { JobsService }               from './transaction-center.jobs.service';
import { JobStartAndPrintTypeModel } from './typings/transaction-center.jobs.start-and-print-type';
import { MessagesService }           from '../../messages/messages.service';

@Component({
  selector   : 'wor-jobs-start-and-print',
  template: require('./transaction-center.jobs.start-and-print.component.html')
})
export class JobStartAndPrintComponent implements OnInit {
  @Input() type : JobStartAndPrintTypeModel = 'printOnly';

  date : string;
  icon : string;
  title: string;

  isError = false;

  constructor (
    public  activeModal      : NgbActiveModal,
    private confirmService   : ConfirmService,
    private globalDatePipe   : GlobalDatePipe,
    @Inject(forwardRef(() => JobsService))
    private jobsService      : JobsService,
    private messagesService  : MessagesService,
    private translateService : TranslateService,
  ) {}

  ngOnInit () : void {
    this.init();
  }

  init () : void {
    switch ( this.type ) {
      case 'printOnly':
        this.icon  = 'print';
        this.title = 'MENU_SPACE.PRINT_JOBS_FOR_DATE';

        break;

      case 'startOnly':
        this.icon  = 'calendar';
        this.title = 'BOOKING_SPACE.START_JOBS_FOR_DATE';

        break;

      case 'startAndPrint':
        this.icon  = 'file-text-o';
        this.title = 'MENU_SPACE.START_AND_PRINT_JOBS_FOR_DATE';

        break;
    }
  }

  is ( type : JobStartAndPrintTypeModel ) : boolean {
    return this.type === type;
  }

  run ( form : NgForm ) : void {
    const dateForJobs = this.globalDatePipe.transform(this.date, 'yyyy-MM-dd');

    Promise.resolve()
    .then(() => this.is('startOnly') || this.is('startAndPrint')
      ? this.confirmService.generic(this.translateService.instant('BOOKING_SPACE.BOOKINGS_FOR_DATE', {
          date: this.globalDatePipe.transform(this.date)
        }))
        .then(() => this.jobsService.getEventsForDate(dateForJobs))
      : Promise.resolve())
    .then(() => this.is('printOnly') || this.is('startAndPrint')
      ? this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.PRINT_JOB_CARDS_FOR_DATE', {
          date: this.globalDatePipe.transform(this.date, 'longDate')
        }))
        .then(() => this.jobsService.getInvoicesForDate(dateForJobs))
        .then(response => {
          if ( response.invoices.marine_invoices.length && !response.invoices.other_invoices.length ) {
            return this.jobsService.bulkPrint({
                invoice_id_string: response.invoice_id_string.marine,
                invoices         : response.invoices.marine_invoices,
                job_card_type    : 'marine'
              });
          }
          else if ( response.invoices.other_invoices.length && !response.invoices.marine_invoices.length ) {
            return this.jobsService.bulkPrint({
                invoice_id_string: response.invoice_id_string.no_marine,
                invoices         : response.invoices.other_invoices,
                job_card_type    : 'default'
              });
          }

          return Promise.all([
            this.jobsService.bulkPrint({
              invoice_id_string: response.invoice_id_string.marine,
              invoices         : response.invoices.marine_invoices,
              job_card_type    : 'marine'
            }),
            this.jobsService.bulkPrint({
              invoice_id_string: response.invoice_id_string.no_marine,
              invoices         : response.invoices.other_invoices,
              job_card_type    : 'default'
            })
          ]);
        })
        .then(response => {
          const pdfs = Array.isArray(response)
            ? response
            : [ response ];

          pdfs.forEach(( pdf : BlobPart ) => {
            if ( !this.isError ) {
              const file    = new Blob([ pdf ], { type: 'application/pdf' });
              const fileURL = URL.createObjectURL(file);

              const newWin = window.open(fileURL, '_blank');

              if ( !newWin || newWin.closed || typeof newWin.closed === 'undefined' ) {
                this.isError = true;

                this.messagesService.show(this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.POPUPS_BLOCKED'), 'error');
              }
            }
          });
        })
      : Promise.resolve())
    .then(() => this.activeModal.close())
    .catch(error => this.messagesService.error(error));
  }
}
